export default "__VITE_ASSET__D2R1q7v5__"